// Copyright (c) 2026 Solartek LLC. All rights reserved.
import { z } from 'zod';
import { paginationQuerySchema, uuidSchema } from '../common.js';
/**
 * PIN mapping (Devices & punches): which employee a device user id — the "PIN" a terminal reports with every punch — belongs
 * to. Two kinds, in the order the normaliser reads them:
 *   `device`  — one device: the device_employee_states row (a person's mapping is marked `manual` and survives device syncs);
 *   `default` — every device without a device mapping: the employee's own device user id (employees.device_user_id).
 */
export const PIN_MAPPING_SCOPES = ['device', 'default'];
/** Same format as employees.device_user_id: the only ids an employee can carry as their default device user id. */
export const DEFAULT_DEVICE_USER_ID_RE = /^[A-Za-z0-9_-]{1,32}$/;
export const pinMappingListQuerySchema = paginationQuerySchema.extend({
    scope: z.enum(PIN_MAPPING_SCOPES).optional(),
    deviceId: uuidSchema.optional(),
    employeeId: uuidSchema.optional(),
    branchId: uuidSchema.optional(),
    /** PIN, employee name or employee number */
    search: z.string().trim().max(100).optional(),
});
export const createPinMappingSchema = z.object({
    employeeId: uuidSchema,
    deviceUserId: z.string().trim().min(1).max(64),
    /** The device the PIN belongs to; null = the employee's default device user id on every device. */
    deviceId: uuidSchema.nullable(),
    /**
     * Device mappings only: move the PIN from the employee it is mapped to on the device, and the employee from the PIN they are
     * mapped to there. Without it both are a 409 CONFLICT (`details.reason` PIN_TAKEN / EMPLOYEE_MAPPED) the UI can confirm.
     */
    replace: z.boolean().optional(),
});
export const PIN_MAPPING_CONFLICTS = ['PIN_TAKEN', 'EMPLOYEE_MAPPED'];
//# sourceMappingURL=pin-mappings.js.map